import type {
    CycleEvaluatorSelection,
    CycleEvaluatorSelectionUpdate,
} from '@/types/cycle-evaluation/CycleEvaluatorSelection';

import { api } from '@/api/api';

export default {
    async updateCycleEvaluatorSelection(
        cycleEvaluatorSelection: CycleEvaluatorSelectionUpdate,
    ): Promise<CycleEvaluatorSelection> {
        const response = await api.put<CycleEvaluatorSelection>(
            `/cycleevaluatorselection/${cycleEvaluatorSelection.id}`,
            cycleEvaluatorSelection,
        );

        return response.data;
    },
};
